export type Tornado = {
  "version": "0.1.0",
  "name": "tornado",
  "instructions": [
    {
      "name": "initializeVault",
      "accounts": [
        {
          "name": "vault",
          "isMut": true,
          "isSigner": false
        },
        {
          "name": "authority",
          "isMut": true,
          "isSigner": true
        },
        {
          "name": "systemProgram",
          "isMut": false,
          "isSigner": false
        }
      ],
      "args": []
    },
    {
      "name": "deposit",
      "accounts": [
        {
          "name": "depositor",
          "isMut": true,
          "isSigner": true
        },
        {
          "name": "vault",
          "isMut": true,
          "isSigner": false
        },
        {
          "name": "systemProgram",
          "isMut": false,
          "isSigner": false
        }
      ],
      "args": [
        {
          "name": "amount",
          "type": "u64"
        }
      ]
    },
    {
      "name": "withdraw",
      "accounts": [
        {
          "name": "vault",
          "isMut": true,
          "isSigner": false
        },
        {
          "name": "project",
          "isMut": true,
          "isSigner": false
        },
        {
          "name": "buyback",
          "isMut": true,
          "isSigner": false
        },
        {
          "name": "holder",
          "isMut": true,
          "isSigner": false
        },
        {
          "name": "mid1",
          "isMut": true,
          "isSigner": false
        },
        {
          "name": "mid2",
          "isMut": true,
          "isSigner": false
        },
        {
          "name": "mid3",
          "isMut": true,
          "isSigner": false
        },
        {
          "name": "authority",
          "isMut": false,
          "isSigner": true,
          "docs": [
            "Authority must match your configured authority PDA or signer"
          ]
        },
        {
          "name": "systemProgram",
          "isMut": false,
          "isSigner": false
        }
      ],
      "args": [
        {
          "name": "projectWallet",
          "type": "publicKey"
        },
        {
          "name": "holderWallet",
          "type": "publicKey"
        },
        {
          "name": "buybackWallet",
          "type": "publicKey"
        },
        {
          "name": "midWallet1",
          "type": "publicKey"
        },
        {
          "name": "midWallet2",
          "type": "publicKey"
        },
        {
          "name": "midWallet3",
          "type": "publicKey"
        },
        {
          "name": "amount1",
          "type": "u64"
        },
        {
          "name": "amount2",
          "type": "u64"
        },
        {
          "name": "amount3",
          "type": "u64"
        }
      ]
    }
  ],
  "errors": [
    {
      "code": 6000,
      "name": "MissingBump",
      "msg": "Bump not found for vault."
    }
  ]
};

export const IDL: Tornado = {
  "version": "0.1.0",
  "name": "tornado",
  "instructions": [
    {
      "name": "initializeVault",
      "accounts": [
        {
          "name": "vault",
          "isMut": true,
          "isSigner": false
        },
        {
          "name": "authority",
          "isMut": true,
          "isSigner": true
        },
        {
          "name": "systemProgram",
          "isMut": false,
          "isSigner": false
        }
      ],
      "args": []
    },
    {
      "name": "deposit",
      "accounts": [
        {
          "name": "depositor",
          "isMut": true,
          "isSigner": true
        },
        {
          "name": "vault",
          "isMut": true,
          "isSigner": false
        },
        {
          "name": "systemProgram",
          "isMut": false,
          "isSigner": false
        }
      ],
      "args": [
        {
          "name": "amount",
          "type": "u64"
        }
      ]
    },
    {
      "name": "withdraw",
      "accounts": [
        {
          "name": "vault",
          "isMut": true,
          "isSigner": false
        },
        {
          "name": "project",
          "isMut": true,
          "isSigner": false
        },
        {
          "name": "buyback",
          "isMut": true,
          "isSigner": false
        },
        {
          "name": "holder",
          "isMut": true,
          "isSigner": false
        },
        {
          "name": "mid1",
          "isMut": true,
          "isSigner": false
        },
        {
          "name": "mid2",
          "isMut": true,
          "isSigner": false
        },
        {
          "name": "mid3",
          "isMut": true,
          "isSigner": false
        },
        {
          "name": "authority",
          "isMut": false,
          "isSigner": true,
          "docs": [
            "Authority must match your configured authority PDA or signer"
          ]
        },
        {
          "name": "systemProgram",
          "isMut": false,
          "isSigner": false
        }
      ],
      "args": [
        {
          "name": "projectWallet",
          "type": "publicKey"
        },
        {
          "name": "holderWallet",
          "type": "publicKey"
        },
        {
          "name": "buybackWallet",
          "type": "publicKey"
        },
        {
          "name": "midWallet1",
          "type": "publicKey"
        },
        {
          "name": "midWallet2",
          "type": "publicKey"
        },
        {
          "name": "midWallet3",
          "type": "publicKey"
        },
        {
          "name": "amount1",
          "type": "u64"
        },
        {
          "name": "amount2",
          "type": "u64"
        },
        {
          "name": "amount3",
          "type": "u64"
        }
      ]
    }
  ],
  "errors": [
    {
      "code": 6000,
      "name": "MissingBump",
      "msg": "Bump not found for vault."
    }
  ]
};
